import { mockMicrositePayload } from './mockMicrosite';

const API_BASE = process.env.REACT_APP_GROWTH_API_URL || window.location.origin;

const safeJson = async (response) => {
  const text = await response.text();
  if (!text) return null;
  try {
    return JSON.parse(text);
  } catch (_error) {
    return null;
  }
};

const request = async (path, options = {}) => {
  const response = await fetch(`${API_BASE}${path}`, {
    credentials: 'omit',
    headers: {
      'Content-Type': 'application/json',
      ...(options.headers || {}),
    },
    ...options,
  });

  const data = await safeJson(response);
  if (!response.ok) {
    const message = data?.error || `Request failed: ${response.status}`;
    throw new Error(message);
  }

  return data;
};

export const resolveMicrosite = async ({ handle, qrToken, host }) => {
  try {
    const params = new URLSearchParams();
    if (handle) params.set('handle', handle);
    if (qrToken) params.set('qrToken', qrToken);
    if (host) params.set('host', host);
    return await request(`/v1/public/resolve?${params.toString()}`, { method: 'GET' });
  } catch (error) {
    if (process.env.NODE_ENV !== 'production' && process.env.REACT_APP_ENABLE_PUBLIC_MOCK_FALLBACK !== 'false') {
      return mockMicrositePayload;
    }
    throw error;
  }
};

export const resolveMockMicrosite = () => {
  if (process.env.NODE_ENV === 'production') {
    throw new Error('Mock microsite is disabled in production.');
  }
  if (process.env.REACT_APP_ENABLE_PUBLIC_MOCK_FALLBACK === 'false') {
    throw new Error('Mock microsite fallback is disabled.');
  }
  return mockMicrositePayload;
};

export const postMicrositeEvents = async ({ sessionToken, events }) => {
  if (!sessionToken || !events?.length) return { ok: false, count: 0 };
  try {
    return await request('/v1/public/events/batch', {
      method: 'POST',
      body: JSON.stringify({ sessionToken, events }),
    });
  } catch (_error) {
    return { ok: false, count: 0 };
  }
};

export const submitMicrositeLead = async ({ sessionToken, blockId, email, phone, payload, consentVersion }) =>
  request('/v1/public/leads', {
    method: 'POST',
    body: JSON.stringify({ sessionToken, blockId, email, phone, payload, consentVersion }),
  });

export const createDonationSession = async ({ sessionToken, amount, blockId }) =>
  request('/v1/public/donations/session', {
    method: 'POST',
    body: JSON.stringify({ sessionToken, amount, blockId }),
  });

export const fetchSponsorCreative = async ({ slotKey = 'inline-primary', siteId }) =>
  request(`/v1/public/ads/fill?slotKey=${encodeURIComponent(slotKey)}&siteId=${encodeURIComponent(siteId || '')}`, {
    method: 'GET',
  });

export const confirmSponsorView = async ({ sessionToken, slotKey, creativeId }) =>
  request('/v1/public/ads/confirm-view', {
    method: 'POST',
    body: JSON.stringify({ sessionToken, slotKey, creativeId }),
  });

export const fetchPulseStatus = async (handle) => {
  try {
    return await request(`/v1/public/status/${encodeURIComponent(handle)}`, { method: 'GET' });
  } catch (_error) {
    return null;
  }
};
